import { useMemo, useRef } from 'react';

import { FormularioDinamicoRuntime } from '../../type/FormularioDinamico';

export interface ArquivoHandlers {
  processor?: (fileObject: any, file: File) => Promise<string>;
  downloader?: (fileObject: any) => Promise<boolean>;
}

export const useArquivoHandlers = (
  formularios: FormularioDinamicoRuntime[],
  fileProcessor?: (
    instanciaId: string,
    fileObject: any,
    file: File
  ) => Promise<string>,
  fileDownloader?: (instanciaId: string, fileObject: any) => Promise<boolean>
): Record<string, ArquivoHandlers> => {
  const handlers = useRef({ fileProcessor, fileDownloader });

  handlers.current = { fileProcessor, fileDownloader };

  const temProcessor = !!fileProcessor;

  const temDownloader = !!fileDownloader;

  return useMemo(
    () =>
      formularios.reduce<Record<string, ArquivoHandlers>>(
        (acumulado, formulario) => ({
          ...acumulado,
          [formulario.id]: {
            processor: temProcessor
              ? (fileObject: any, file: File) =>
                  handlers.current.fileProcessor!(
                    formulario.id,
                    fileObject,
                    file
                  )
              : undefined,
            downloader: temDownloader
              ? (fileObject: any) =>
                  handlers.current.fileDownloader!(formulario.id, fileObject)
              : undefined
          }
        }),
        {}
      ),
    [formularios, temProcessor, temDownloader]
  );
};
